const risks = [
  {
    risk: "Fake Spreadsheet Websites",
    solution: "Verify trusted sources and check for community recommendations before relying on any spreadsheet resource.",
    icon: "ri-alert-line",
  },
  {
    risk: "Suspicious External Links",
    solution: "Always check website reputation and avoid clicking on unverified links from unknown spreadsheet sources.",
    icon: "ri-links-line",
  },
  {
    risk: "Wrong Product Information",
    solution: "Compare information across multiple respected spreadsheet resources to ensure accuracy and consistency.",
    icon: "ri-error-warning-line",
  },
  {
    risk: "Outdated Listings",
    solution: "Look for regularly updated spreadsheets with clear version dates and recent activity indicators.",
    icon: "ri-timer-line",
  },
];

export default function SafetySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16 max-w-6xl mx-auto">
          {/* Left */}
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
              Safety &amp; Trust
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
              How To Stay Safe When Using{" "}
              <span className="text-primary-500">Shopping Spreadsheets</span>
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8">
              While spreadsheet resources offer incredible convenience for product discovery, it is important to practice safe browsing habits. Here are the key risks to be aware of and the solutions to protect yourself.
            </p>

            {/* Safety tips */}
            <div className="space-y-3">
              {[
                { tip: "Verify the source before trusting any spreadsheet", icon: "ri-check-double-line" },
                { tip: "Never share personal information through spreadsheet platforms", icon: "ri-lock-line" },
                { tip: "Cross-reference product details with official listings", icon: "ri-refresh-line" },
                { tip: "Use secure connections when browsing spreadsheet resources", icon: "ri-shield-line" },
              ].map((tip) => (
                <div key={tip.tip} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${tip.icon} text-secondary-600 text-xs`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{tip.tip}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Risk Table */}
          <div className="lg:w-3/5 w-full">
            <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
              <div className="p-5 border-b border-background-200/70">
                <h3 className="font-heading text-lg font-bold text-foreground-900">Common Risks &amp; Solutions</h3>
              </div>
              <div className="divide-y divide-background-200/50">
                {risks.map((item) => (
                  <div key={item.risk} className="flex items-start gap-4 p-5 hover:bg-background-50/50 transition-colors">
                    <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-accent-600`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-1.5">
                        <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full inline-block w-fit whitespace-nowrap">Risk</span>
                        <span className="text-sm font-semibold text-foreground-800">{item.risk}</span>
                      </div>
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                        <span className="text-xs font-semibold text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded-full inline-block w-fit whitespace-nowrap">Solution</span>
                        <span className="text-sm text-foreground-600">{item.solution}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}